module.exports = __webpack_public_path__ + "static/media/1920x1080.41053d6b.png";